import { Box } from "@mui/material";
import { UserLogin } from "../../@components/Login/UserLogin";
import { LayoutWrapper } from "../../@components/ReusableComponents/LayoutWrapper";

export const Login = () => {
  return (
    <Box
      sx={{
        height: "100vh",
        backgroundImage: "url('/assets/loginBackground1.png')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: {
          xs: "center",
          sm: "center",
          md: "flex-start",
        },
        pl: {
          xs: 0,
          sm: 0,
          md: "10%",
          xl: "15%",
        },
      }}
    >
      <LayoutWrapper>
        <Box sx={{ alignItems: "left" }}>
          <UserLogin />
        </Box>
      </LayoutWrapper>
    </Box>
  );
};
